<!--Sidebar-->
<pmd-sidebar aria-label="Left Sidebar" #leftSidebar placement="left" position="slidepush"
	class="pmd-sidebar pmd-sidebar-with-brand pmd-sidebar-slide-push bg-white" isOpenWidth="1200" role="navigation" tabindex="0"
	id="leftSidebarMenu" [isOpen]="isOpenSidebar">
	<app-sidebar></app-sidebar>
</pmd-sidebar>

<!--Navbar-->
<pmd-navbar class="navbar-expand-xl fixed-top navbar-dark bg-primary py-1 border-bottom" id="navbar">
	<app-navbar></app-navbar>
</pmd-navbar>
<!--/.Navbar-->

<!--Main Content Area-->
<main class="pmd-content home-layout" aria-label="Main Content" id="mainContent" tabindex="0">
	<div class="d-flex align-items-center d-block d-sm-none mb-3" *ngIf="headerData">
		<button type="button" *ngIf="headerData.currentModule !=''" (click)="backClicked()" pmdRipple pmd-btn-fab color="light" size="xs" class="me-2">
			<i class="material-icons material-symbols-rounded pmd-icon-xs">arrow_back</i>
		</button>
		<div>
			<ng-container *ngIf="headerData.currentTitle !=''">
				<h1 tabindex="0" class="mb-0 h2">{{headerData.currentTitle}}</h1>
			</ng-container>
			<ng-container *ngIf="headerData.currentTitle == undefined || headerData.currentTitle ==''">
				<h1 tabindex="0" class="mb-0 h2" *ngIf="headerData.invoiceNumber!=undefined">{{headerData.currentPage}} ({{headerData.invoiceNumber}})</h1>
				<h1 tabindex="0" class="mb-0 h2" *ngIf="headerData.invoiceNumber==undefined">{{headerData.currentPage}}</h1>
			</ng-container>
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb pmd-breadcrumb">
					<li class="breadcrumb-item" ><a  href="/dashboard">Dashboard</a></li>
					<li class="breadcrumb-item"><a href="/dashboard">Invoices</a></li>
					<li class="breadcrumb-item active" aria-current="page" tabindex="0">Create Invoice</li>
				</ol>
			</nav>
		</div>
	</div>

	<!-- <div class="d-flex align-items-center d-none d-sm-flex"> 
		<button type="button" *ngIf="headerData.currentModule !=''" (click)="backClicked()" pmdRipple pmd-btn-fab color="primarylight" size="sm" class="me-3">
			<i class="material-icons material-symbols-rounded pmd-icon-sm">arrow_back</i>
		</button>
		<div >
			<ng-container *ngIf="headerData.currentTitle !=''">
				<h1 tabindex="0" class="mb-0 text-white h3">{{headerData.currentTitle}}</h1>
			</ng-container>
			<ng-container *ngIf="headerData.currentTitle == undefined || headerData.currentTitle ==''">
				<h1 tabindex="0" class="mb-0 text-white h3" *ngIf="headerData.invoiceNumber!=undefined">{{headerData.currentPage}} ({{headerData.invoiceNumber}})</h1>
				<h1 tabindex="0" class="mb-0 text-white h3" *ngIf="headerData.invoiceNumber==undefined">{{headerData.currentPage}}</h1>
			</ng-container>
			
			<nav *ngIf="headerData.currentPage != 'Dashboard'" aria-label="breadcrumb" class="breadcrumb mb-0">
				<ul class="breadcrumb pmd-breadcrumb pmd-breadcrumb-dark">
					<li class="breadcrumb-item"><a href="javascript:void(0)" routerLink="/dashboard">Dashboard</a></li>
					<li class="breadcrumb-item" *ngIf="headerData.currentModule !=''"><a href="javascript:void(0)" routerLink="{{headerData.currentModulePath}}">{{headerData.currentModule}}</a></li>
					<li class="breadcrumb-item active" aria-current="page" tabindex="0">{{headerData.currentPage}}</li>
				</ul>
			</nav>
		</div>
	</div> -->

	<router-outlet></router-outlet>
</main>

<!-- Help & Support Modal -->
<help></help>
<!-- /END/ Help & Support Modal -->